import { FullscreenHtml } from '@components/helpers'

export function Loading() {
  return (
    <FullscreenHtml zIndexRange={[0, 1]}>
      <div className="flex h-full flex-col items-center justify-center overflow-hidden">
        <p className="animate-pulse text-3xl text-shadow-lg">LOADING</p>
      </div>
    </FullscreenHtml>
  )
}

// animated rails SVG
/* 
<style>{`
  @keyframes rail-slide {
    from { transform: translateX(0); }
    to { transform: translateX(-40px); }
  }
  .animate-rail-slide {
    animation: rail-slide ${speed} linear infinite;
  }
`}</style>
<svg width="300" height="120" viewBox="0 0 300 120" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="fade-grad" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stopColor={bgColor} stopOpacity="1" />
      <stop offset="15%" stopColor={bgColor} stopOpacity="0" />
      <stop offset="85%" stopColor={bgColor} stopOpacity="0" />
      <stop offset="100%" stopColor={bgColor} stopOpacity="1" />
    </linearGradient>

    <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
      <feGaussianBlur in="SourceAlpha" stdDeviation="1" />
      <feOffset dx="0" dy="1" />
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>

  <g className="animate-rail-slide" filter="url(#shadow)">
    {Array.from({ length: 9 }).map((_, i) => (
      <rect
        key={i}
        x={i * 40}
        y="35"
        width="25"
        height="50"
        fill={sleeperColor}
        className="opacity-80"
      />
    ))}
  </g>

  <line
    x1="0"
    y1="42"
    x2="300"
    y2="42"
    stroke={railColor}
    strokeWidth="4"
    strokeLinecap="round"
  />
  <line
    x1="0"
    y1="78"
    x2="300"
    y2="78"
    stroke={railColor}
    strokeWidth="4"
    strokeLinecap="round"
  />

  <rect width="300" height="120" fill="url(#fade-grad)" className="pointer-events-none" />
</svg> 
*/
